'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2017 Vector Creations Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var KeyRequestHandler = function () {
    function KeyRequestHandler(matrixClient) {
        (0, _classCallCheck3.default)(this, KeyRequestHandler);

        this._matrixClient = matrixClient;

        // the user/device for which we currently have a dialog open
        this._currentUser = null;
        this._currentDevice = null;

        // userId -> deviceId -> [keyRequest]
        this._pendingKeyRequests = (0, _create2.default)(null);
    }

    (0, _createClass3.default)(KeyRequestHandler, [{
        key: 'handleKeyRequest',
        value: function handleKeyRequest(keyRequest) {
            var userId = keyRequest.userId;
            var deviceId = keyRequest.deviceId;
            var requestId = keyRequest.requestId;

            if (!this._pendingKeyRequests[userId]) {
                this._pendingKeyRequests[userId] = (0, _create2.default)(null);
            }
            if (!this._pendingKeyRequests[userId][deviceId]) {
                this._pendingKeyRequests[userId][deviceId] = [];
            }

            // check if we already have this request
            var requests = this._pendingKeyRequests[userId][deviceId];
            if (requests.find(function (r) {
                return r.requestId === requestId;
            })) {
                console.log("Already have this key request, ignoring");
                return;
            }

            requests.push(keyRequest);

            if (this._currentUser) {
                // ignore for now
                console.log("Key request, but we already have a dialog open");
                return;
            }

            this._processNextRequest();
        }
    }, {
        key: 'handleKeyRequestCancellation',
        value: function handleKeyRequestCancellation(cancellation) {
            // see if we can find the request in the queue
            var userId = cancellation.userId;
            var deviceId = cancellation.deviceId;
            var requestId = cancellation.requestId;

            if (userId === this._currentUser && deviceId === this._currentDevice) {
                console.log("room key request cancellation for the user we currently have a" + " dialog open for");
                // TODO: update the dialog. For now, we just ignore the
                // cancellation.
                return;
            }

            if (!this._pendingKeyRequests[userId]) {
                return;
            }
            var requests = this._pendingKeyRequests[userId][deviceId];
            if (!requests) {
                return;
            }
            var idx = requests.findIndex(function (r) {
                return r.requestId === requestId;
            });
            if (idx < 0) {
                return;
            }
            console.log("Forgetting room key request");
            requests.splice(idx, 1);
            if (requests.length === 0) {
                delete this._pendingKeyRequests[userId][deviceId];
                if ((0, _keys2.default)(this._pendingKeyRequests[userId]).length === 0) {
                    delete this._pendingKeyRequests[userId];
                }
            }
        }
    }, {
        key: '_processNextRequest',
        value: function _processNextRequest() {
            var _this = this;

            var userId = (0, _keys2.default)(this._pendingKeyRequests)[0];
            if (!userId) {
                return;
            }
            var deviceId = (0, _keys2.default)(this._pendingKeyRequests[userId])[0];
            if (!deviceId) {
                return;
            }
            console.log('Starting KeyShareDialog for ' + userId + ':' + deviceId);

            var finished = function finished(r) {
                _this._currentUser = null;
                _this._currentDevice = null;

                if (r) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = (0, _getIterator3.default)(_this._pendingKeyRequests[userId][deviceId]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var req = _step.value;

                            req.share();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                delete _this._pendingKeyRequests[userId][deviceId];
                if ((0, _keys2.default)(_this._pendingKeyRequests[userId]).length === 0) {
                    delete _this._pendingKeyRequests[userId];
                }

                _this._processNextRequest();
            };

            var KeyShareDialog = _index2.default.getComponent("dialogs.KeyShareDialog");
            _Modal2.default.appendTrackedDialog('Key Share', 'Process Next Request', KeyShareDialog, {
                matrixClient: this._matrixClient,
                userId: userId,
                deviceId: deviceId,
                onFinished: finished
            });
            this._currentUser = userId;
            this._currentDevice = deviceId;
        }
    }]);
    return KeyRequestHandler;
}();

exports.default = KeyRequestHandler;
module.exports = exports['default'];
//# sourceMappingURL=KeyRequestHandler.js.map